import { mq, padding, spacing, styled } from '@thg-commerce/enterprise-theme'
import { BlankDropdown, Button } from '@thg-commerce/gravity-elements'

export const BUTTON_HEIGHT = '48px'

export const StyledHorizontalFacetContent = styled.div<{
  showFilteredItems?: boolean
}>`
  overflow: hidden;
  height: ${(props) =>
    props.showFilteredItems
      ? 'auto'
      : props.theme.widget.productList?.horizontalFacets?.container
          ?.facetWrapperHeight || BUTTON_HEIGHT};
`

export const HorizontalFacetWrapper = styled.div<{
  isAlignTop?: boolean
  stickyOnDesktop?: boolean
  scrolled?: boolean
  hideMargin?: boolean
}>`
  display: flex;
  margin: ${(props) =>
    props.hideMargin
      ? 0
      : `${spacing(
          props.theme.widget.productList?.horizontalFacets?.container
            .marginTop || 4,
        )} 0 ${spacing(
          props.theme.widget.productList?.horizontalFacets?.container
            ?.marginBottomSpacing || 2,
        )}`};
  border-top: 1px solid ${(props) => props.theme.colors.palette.greys.light};
  border-bottom: 1px solid ${(props) => props.theme.colors.palette.greys.light};
  padding: ${(props) =>
    `${spacing(
      props.theme.widget.productList?.horizontalFacets?.container
        ?.paddingTopSpacing || 3,
    )} 0;`};
  align-items: ${(props) => (props.isAlignTop ? 'flex-start' : 'center')};
  justify-content: space-between;

  ${(props) =>
    `
    &::after {
      content: '';
      position: absolute;
      width: 100vw;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
      background: ${props.theme.colors.palette.greys.white};
      height: 100%;
      z-index: -1;
    }`}

  ${(props) =>
    props.stickyOnDesktop &&
    props.scrolled &&
    `
    padding: ${spacing(3)} 0;
    &::after {
      border-bottom: solid ${props.theme.colors.palette.greys.light} 1px;
    }`}
  };
`

export const FacetContainer = styled.div<{
  gap: { column?: number; row?: number }
}>`
  display: flex;
  position: static;
  flex: 0 1 auto;
  flex-wrap: wrap;
  align-items: center;
  align-content: flex-start;
  flex-direction: row;
  width: 100%;

  ${(props) =>
    props.theme.widget.productList?.horizontalFacets?.container.maxWidth &&
    `max-width:${props.theme.widget.productList.horizontalFacets.container.maxWidth};`}
  ${(props) =>
    props.theme.widget.productList?.horizontalFacets?.container?.padding
      ?.mobile &&
    padding(
      props.theme.widget.productList.horizontalFacets.container.padding.mobile,
    )}
  ${(props) => props.gap?.row && `row-gap: ${spacing(props.gap.row)}`};
  ${(props) => props.gap?.column && `column-gap: ${spacing(props.gap.column)}`};

  ${(props) => mq(props.theme.breakpointUtils.map, 'lg')} {
    ${(props) =>
      props.theme.widget.productList?.horizontalFacets?.container?.padding
        ?.desktop &&
      padding(
        props.theme.widget.productList.horizontalFacets.container.padding
          .desktop,
      )}
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-wrap: nowrap;
  column-gap: ${spacing(2)};
  margin-left: ${spacing(2)};
  height: ${BUTTON_HEIGHT};
  align-items: center;
  justify-content: center;
`
export const StyledBlankDropdown = styled(BlankDropdown)<{
  isBrandFacet: boolean
  maxWidth: string
}>`
  max-width: ${(props) => props.maxWidth};
  min-width: 160px;
  flex-grow: 1;

  ${(props) => mq(props.theme.breakpointUtils.map, 'lg')} {
    min-width: 164px;
  }

  & > div > div {
    ${(props) =>
      props.isBrandFacet && {
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
      }}
  }
`
const MINIMUM_FILTER_ACTION_WIDTH = '60px'

export const ActionFilterButton = styled(Button)`
  &:focus {
    border-color: ${(props) => props.theme.colors.palette.greys.darker};
  }

  &:active,
  &:hover {
    justify-content: end;
    min-width: ${MINIMUM_FILTER_ACTION_WIDTH};
  }
`
